import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';

/* eslint-disable */
const _createFetchParams = (sortBy, search, pagination, requesterId, companyId, type, itemId) => {
    return {
        ordering:  sortBy,
        search,
        ...pagination,
        requester: requesterId,
        company:   companyId,
        type,
        cat_item:  itemId
    };
};
/* eslint-enable */
const
    name = 'servicesOffering',
    exports = {
        createFetchParams: _createFetchParams,
        ...storeModuleFactory({
            name,
            timeout:  TIMEOUT_STORE.TIMEOUT_STORE_BIG,
            endpoint: endpoints.serviceNow.serviceOfferingEndpoint
        })
    };


module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/servicesOffering.js